export default [
  {
    path: 'pemasok',
    redirect: { name: 'suppliers' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'suppliers',
        component: () => import('@pages/suppliers/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Pemasok',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Pemasok',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'suppliers-add',
        component: () => import('@pages/suppliers/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Pemasok',
          navActiveLink:'suppliers',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Pemasok',
              to: { name: 'suppliers' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'suppliers-edit',
        component: () => import('@pages/suppliers/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Pemasok',
          navActiveLink:'suppliers',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Pemasok',
              to: { name: 'suppliers' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      }
    ]
  }
]